import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {toBuildTypeId} from '../../../types'
import {makeResource} from '../../../utils/makeResource'

import type {OverviewBreadcrumbsComponent} from './OverviewBreadcrumbs'
import {query} from './OverviewBreadcrumbs.queries'

export const OverviewBreadcrumbsEntryPoint: EntryPoint<
  OverviewBreadcrumbsComponent,
  LoaderFunctionArgs
> = {
  root: makeResource(
    'OverviewBreadcrumbs',
    () =>
      import(
        /* webpackChunkName: "OverviewBreadcrumbs" */
        './OverviewBreadcrumbs'
      ),
  ),
  getPreloadProps({params}) {
    const {projectId, buildTypeId: buildTypeIdString, buildId} = params
    const buildTypeId = buildTypeIdString != null ? toBuildTypeId(buildTypeIdString) : undefined

    return {
      queries: {
        main: {
          parameters: getRequest(query),
          variables: {
            projectLocator: `id:${projectId}`,
            buildTypeLocator: `id:${buildTypeId}`,
            buildLocator: `id:${buildId}`,
            fetchProject: projectId != null,
            fetchBuildType: buildTypeId != null,
            fetchBuild: buildId != null,
          },
        },
      },
    }
  },
}
